export default value =>
  value - Math.floor(value) >= 0.5
    ? `${((value - 1) / 100).toFixed(2).replace('.', ',')}€`
    : `${(value / 100).toFixed(2).replace('.', ',')}€`
